import React from 'react'
import styles from './ComponentHeader.module.css'

interface ComponentHeaderProps {
  children: React.ReactNode
  className?: string
}

const ComponentHeader: React.FC<ComponentHeaderProps> = ({
  children,
  className = '',
}) => {
  const baseClasses = `component-header-style text-[var(--balance-text-color)] font-semibold text-lg px-4 md:px-6 py-2 w-full rounded-t-lg text-left ${styles.componentHeader}`

  return <h4 className={`${baseClasses} ${className}`.trim()}>{children}</h4>
}

export default ComponentHeader
